import React from "react";
import { experienceData } from "../data/mock";
import { Card, CardContent } from "./ui/card";
import { Film, Tv, Clapperboard, Briefcase } from "lucide-react";
import { Separator } from "./ui/separator";

const iconMap = {
  Film: Film,
  Tv: Tv,
  Clapperboard: Clapperboard,
};

const Experience = () => {
  return (
    <section id="experience" className="relative py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section header */}
        <div className="flex items-center gap-3 mb-6">
          <Briefcase className="w-5 h-5 text-teal-400" />
          <span className="font-nunito text-white text-sm tracking-[0.25em] uppercase font-bold">
            Experiencia Artística
          </span>
          <div className="flex-1 h-px bg-teal-500/20" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start mb-16">
          <div className="backdrop-blur-md rounded-2xl p-6">
            <h2 className="font-bebas text-5xl md:text-6xl tracking-wide mb-4 text-black lg:text-teal-400">
              Trayectoria en <span className="text-teal-400">Doblaje</span>
            </h2>
            <p className="font-nunito text-lg text-slate-200">
              Ha trabajado en doblaje dentro del estudio{" "}
              <span className="text-teal-400 font-semibold">{experienceData.studio}</span>, participando en diversos
              proyectos audiovisuales.
            </p>
          </div>
          <div className="relative group overflow-hidden rounded-2xl">
            <img
              src={experienceData.studioImage}
              alt="Aurie en estudio de doblaje"
              className="w-full h-[280px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent" />
            <p className="absolute bottom-4 left-6 font-nunito text-sm text-white/60 italic">
              {experienceData.description}
            </p>
          </div>
        </div>

        {/* Categories grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {experienceData.categories.map((category, idx) => {
            const IconComponent = iconMap[category.icon] || Film;
            return (
              <Card
                key={idx}
                className="backdrop-blur-md border-slate-300/50 hover:border-teal-500/30 transition-all duration-500 group hover:-translate-y-1 hover:shadow-xl hover:shadow-teal-500/5"
              >
                <CardContent className="p-8">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 rounded-xl bg-teal-500/10 flex items-center justify-center group-hover:bg-teal-500/20 transition-colors duration-300">
                      <IconComponent className="w-6 h-6 text-teal-400" />
                    </div>
                    <h3 className="font-bebas text-2xl text-black tracking-wide">{category.title}</h3>
                  </div>
                  <Separator className="bg-slate-300/50 mb-6" />
                  <ul className="space-y-3">
                    {category.items.map((item, i) => (
                      <li
                        key={i}
                        className="flex items-start gap-3 font-nunito text-slate-200 group-hover:text-slate-100 transition-colors duration-300"
                      >
                        <span className="w-1.5 h-1.5 rounded-full bg-teal-600 mt-2 shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Experience;
